<template>
    <button :class="favoriteClass" :disabled="isProcessing" @click="toggleFavorite()">
        <common-icon :name="iconName" size="large"></common-icon>
    </button>
</template>

<script>
    import UsersAPI from 'api/UsersAPI'

    export default {
        props: {
            user: { type: Object, required: true },
        },

        data() {
            return {
                isProcessing: false,
                isFavorited: this.user.isFavorited,
            }
        },

        computed: {
            favoriteClass() {
                return {
                    'card-favorite': true,
                    'card-favorite--is-on': this.isFavorited,
                }
            },

            iconName() {
                return this.isFavorited ? 'heart-on' : 'heart-off'
            },
        },

        methods: {
            toggleFavorite() {
                this.isProcessing = true

                UsersAPI[this.isFavorited ? 'removeFromFavorites' : 'addToFavorites'](
                    this.$auth.getActiveMember().id,
                    this.user.id,
                ).then(() => {
                    this.isProcessing = false
                })

                this.isFavorited = !this.isFavorited
            },
        },
    }
</script>
